export default __webpack_public_path__ + "static/media/t1.76ef3e18.png";